import classNames from "classnames/bind";
import TrustpilotLogo from "public/icons/illustrations/trustpilotLogo.svg";
import styles from "./Service.module.scss";

const cx = classNames.bind(styles);

export interface ServiceProps {
    rating: number;
    totalReviews: number;
    className?: string;
    service: string;
}

const Service = ({ rating, totalReviews, className, service }: ServiceProps) => (
    <div className={cx("service", className)}>
        <div className={cx("icon")}>
            <figure className={cx("icon")}>
                {service === "trustpilot" ? (
                    <TrustpilotLogo className={cx("icon", "trustpilot")} />
                ) : undefined}
            </figure>
        </div>
        <div className={cx("ratingWrapper")}>
            <p className={cx("rating")}>{rating}/5</p>
            <div className={cx("stars")}>
                {[...Array(5)].map((_, i) => (
                    <div
                        key={i}
                        className={cx("star", { filled: i <= rating })}
                        data-value={(-(i - rating)).toFixed(1)}
                    ></div>
                ))}
            </div>
        </div>
        <div className={cx("totalReviews")}>
            Independent Service Rating based on{" "}
            <span className={cx("semiBold")}>{totalReviews} verified reviews</span>
        </div>
    </div>
);

export default Service;
